import { useEffect } from 'react';
import { useStores } from '../../../../app/root/domain/stores/useStores';
import { IPoi } from '../../../domain/models/IPoi';

export function useSetPoiResults(pois: IPoi[]) {
	const { poiStore } = useStores();

	useEffect(() => {
		poiStore.setResults(pois);
	}, [pois, poiStore]);
}
